import React from 'react';
import { TrainingShell } from '../components/TrainingV2';

const DataIntelligenceTraining: React.FC = () => {
  return (
    <TrainingShell
      moduleId="data-intelligence"
      moduleName="E-Unify Data Intelligence Training"
      backUrl="/learn"
    />
  );
};

export default DataIntelligenceTraining;
